/**
 * ThingListMetaFields settings
 * @type {{name: string, value: Array<string>}}
 */
export default {
    name: 'ThingListMetaFields',
    value: ['query', 'limit', 'offset', 'order']
};



// WEBPACK FOOTER //
// ./app/services/api/things/things.config.js